<template>
    <div class="container pt-6">
        <div class="mb-4">
            <div class="row align-items-center">
                <div class="col text-center">
                    <strong class="fs-3 block-title">Blogs</strong>
                </div>
            </div>

            <div class="row pt-5">
                <div class="col-md-3 col-sm-12 col-lg-3 mb-5" v-for="  blog in insblog   " :key="blog.id">
                    <router-link :to="{ name: 'View blogs', params: { blogUrl: blog.blogUrl } }">
                        <div class="card rounded-0 mb-2 h-100 ">
                            <div class="card-body p-0 ">
                                <img :src="blog.blogPic" class="img-fluid " @error="onImageError(blog.id)" id="" />
                                <div class="p-2 ">
                                    <h6>{{ blog.title }}</h6>
                                    <p>{{ blog.location }}</p>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import axios from "axios";
import $ from "jquery";
import moment from "moment";



export default {
    data() {
        return {

            insblog: [],
            maxWords: 20

        };
    },
    mounted() {
        this.getInsProfile();



    },
    methods: {

        getTruncatedText(text) {
            // Remove specified HTML tags (e.g., 'img') from the text
            const withoutImgTags = text.replace(/<img[^>]*>/g, '');

            // Convert HTML to plain text
            const plainText = withoutImgTags.replace(/<[^>]+>/g, '');

            // Split the text into words and get the first 'maxWords' words
            const words = plainText.split(/\s+/);
            const truncatedWords = words.slice(0, 20);

            // Join the words and add ellipsis if needed
            const truncatedText = truncatedWords.join(' ');
            return words.length > this.maxWords ? truncatedText + '...' : truncatedText + '...';
        },


        // getFormattedCategory(category) {
        //     return category[0];
        // },


        toggleShowAllCards() {
            this.showAllCards = !this.showAllCards;
        },

        formatDateTime(date) {
            return moment(date, 'DD-MM-YYYY').format('MMMM Do YYYY');
        },


        // onImageError() {
        //     var sampleImg = "https://s3.ap-southeast-1.amazonaws.com/static.foodclubasia.com/user-profile-pictures/user-logo.webp";
        //     $(".insiderProfilePic").attr("src", sampleImg);
        // },




        onImageError() {
            var sampleImg =
                "https://s3.ap-southeast-1.amazonaws.com/static.foodclubasia.com/user-logo-insider.jpg";
            $("#insPro").attr("src", sampleImg);
        },




        getInsProfile() {
            const insiderBlogUrl = this.$route.params.insiderBlogUrl;

            this.loading = true;
            axios
                .post(
                    "https://wh9ouahcq0.execute-api.ap-southeast-1.amazonaws.com/Prod/community",
                    {
                        routeName: "/get-insider-details",
                        blogName: insiderBlogUrl,
                        regionName: "ap-southeast-1"
                        // regionName: "ap-south-1"
                    }
                )
                .then(response => {
                    // console.log("API Response:", response.data.insiderDetails);
                    if (response.data && response.data.insiderDetails) {
                        this.insprofile = response.data.insiderDetails;
                        this.insProPicture =
                            "https://s3.ap-southeast-1.amazonaws.com/static.foodclubasia.com/user-profile-pictures/" +
                            this.insprofile[0].id +
                            ".png";

                        // "https://s3.ap-south-1.amazonaws.com/static.foodclubasia.com/user-profile-pictures/" +
                        // this.insprofile[0].id +
                        // ".png";
                        this.getInsBlog(); // Call getInsBlog after insprofile is populated
                        this.id = response.data.insiderDetails.id;
                    } else {
                        this.error = "Invalid API response structure or empty data";
                    }
                })
                .catch(error => {
                    console.error("Error fetching insprofile details:", error);
                    this.error = "Error fetching insprofile details. Please try again later.";
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getInsBlog() {
            const insiderId = this.insprofile ? this.insprofile[0].id : null;

            if (insiderId) {
                axios
                    .post(
                        "https://wh9ouahcq0.execute-api.ap-southeast-1.amazonaws.com/Prod/community",
                        {
                            routeName: "/get-insider-details",
                            blogName: this.$route.params.insiderBlogUrl,
                            regionName: "ap-southeast-1"
                            // regionName: "ap-south-1"
                        }
                    )
                    .then(response => {
                        // console.log("API Response:", response.data.blogBody);
                        if (response.data && response.data.Category) {
                            this.category = response.data.Category;
                        }

                        if (response.data && response.data.Topics) {
                            this.topics = response.data.Topics;
                        }
                        if (response.data && response.data.blogBody) {
                            this.insblog = response.data.blogBody.filter(
                                blog => blog.insiderId === insiderId
                            );
                            this.insblog.forEach(blog => {
                                blog.blogPic =
                                    "https://s3.ap-southeast-1.amazonaws.com/static.foodclubasia.com/blog/" +
                                    blog.id +
                                    ".png";

                                // "https://s3.ap-south-1.amazonaws.com/static.foodclubasia.com/blog/" +
                                // blog.id +
                                // ".png";
                            });
                        } else {
                            this.error = "Invalid API response structure or empty data";
                        }
                    })
                    .catch(error => {
                        console.error("Error fetching insprofile details:", error);
                        this.error =
                            "Error fetching insprofile details. Please try again later.";
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                console.error("Insider ID is not available");
            }
        },



    }


}
// };
</script>





<style scoped>
#main-header {
    background-image: url(@/assets/2background-image.jpg);
    background-size: cover;
    width: 100%;
    height: 400px;
    align-items: center;
    display: flex;
    margin-top: 72px;
}

.pt {
    padding-top: 100px;
}


.text-theme {
    color: #ffffff;

}

.fs-3 {
    font-size: calc(1.325rem + 0.9vw) !important;

}

.btn-theme {
    background-color: #21afb4;
    color: white;
}

.btn-theme:hover {
    background-color: #2d9599;
    color: white;
}

.ins-pro-picture {
    top: -60px;
    position: relative;
}

/* .img-thumbnail {
    height: 250px;
} */


.img-container {
    position: relative;
    text-align: center;
    color: white;
    overflow: hidden;
}

.img-container img {
    width: 100%;
    min-height: 100%;
    object-fit: cover;
}

.img-container:hover>img {
    opacity: 0.8;
}

.view-more {
    color: #355b7c;
    text-decoration: underline;
    font-size: smaller;
}

.pr-5 {
    display: inline-block;
    margin-left: 10px;
    /* color: rgb(98, 165, 204) */
    color: #355b7c;
    text-decoration: underline;
}


* {
    box-sizing: border-box;
}


a {
    color: black;
    text-decoration: none;

}


.mb-5 {
    margin-bottom: 3rem !important;
}

.h-100 {
    height: 100% !important;
}

.fab {
    border-radius: 50%;
    align-items: center;
    padding: 10px;
    font-size: 20px;
    margin: 5px;
}

.fab:hover {
    opacity: 0.7;
}

.fa-facebook {
    background: #3b5998;
    color: white;
}

.fa-twitter {
    background: #55acee;
    color: white;
}

.fa-linkedin {
    background: #007bb5;
    color: white;
}

.fa-instagram {
    background: #cb2027;
    color: white;
}

.fa-tiktok {
    color: white;
}

.fas {
    color: rgb(232, 14, 31);
    /* padding-top: 15px; */
}

.rank {

    color: #cb2027;

}

.view {
    color: #355b7c;
}

.pt-6 {
    padding-top: 100px;
}
</style>